import { useApi } from 'services';

export const useGetPersonById = (idPerson) => useApi(
    `/v2/person/${idPerson}`,
    'GET',
    {},
    {},
    true
);

export const useGetPersons = (query) => useApi(
    '/v2/person',
    'GET',
    {...query},
    {}
);

export const useGetPersonsSync = (query) => useApi(
    '/v2/person',
    'GET',
    {...query},
    {},
    true
);

export const useGetSicCode = (query) => useApi(
    '/v2/person/infos/sic-code',
    'GET',
    {...query},
    {},
    true
);

export const usePersonList = () => useApi(
    `/query`,
    'POST',
    {}, 
    {}, 
    true)
